import { Location } from '../../../types/Location';

export const getRedirectUrl = ({ pathname = '', state }: Location) => {
  if (pathname.includes('/account/proposals')) {
    return pathname;
  }
  return state?.redirectUrl;
};

export const getLayoutProps = ({ pathname = '' }: Location) => {
  if (pathname.includes('/account/proposals')) {
    return { withDivider: false, withSidebar: false, isFullWidth: true };
  }
  if (pathname.includes('/account/quoting/request/new')) {
    return { withDivider: false, withSidebar: false, isFullWidth: true };
  }
  return { withDivider: false, withSidebar: true, isFullWidth: true };
};
